module.exports = __webpack_public_path__ + "media/country_flags/io-126c869e.png";